import { render, staticRenderFns } from "./GeneralStep.vue?vue&type=template&id=67b105fa"
import script from "./GeneralStep.vue?vue&type=script&lang=js"
export * from "./GeneralStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports